module.exports = __webpack_public_path__ + "static/media/img2_1.40fc74e0.png";